import { render } from "./TheStatute.vue?vue&type=template&id=e6e25d34&scoped=true"
const script = {}

import "./TheStatute.vue?vue&type=style&index=0&id=e6e25d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e25d34"]])

export default __exports__